$(document).ready(function () {
  const maxLength = 216;
  $('.show-read-more').each(function () {
    const myStr = $(this).find('div').html();
    if ($.trim(myStr).length > maxLength) {
      const newStr = myStr.substring(0, maxLength);
      const removedStr = myStr.substring(maxLength, $.trim(myStr).length);
      $(this).empty().html(newStr);
      $(this).append(' <a href="javascript:void(0);" class="read-more">... Read more</a>');
      $(this).append('<span class="more-text">' + myStr + '</span>');
    }
  });
  $('.read-more').click(function () {
    // $(this).siblings(".more-text").contents().unwrap();
    const htm = $(this).parent().find('.more-text').html();
    $(this).parent().html(htm);
    $(this).remove();
  });

  /* Product Tabs Hide & Show */
  $('.tab3, .tab4').click(function () {
    $('.cstm-image1, .cstm-points, .cstm-how-to-use').hide();
  });
  $('.tab1').click(function () {
    $('.cstm-image1, .cstm-points, .cstm-how-to-use').show();
  });
});
